export enum PlaybackState {
  Stopped = 'stopped',
  Playing = 'playing',
  Waiting = 'waiting',
  Interrupted = 'interrupted'
}
